import { Button } from "react-bootstrap";
import Icon from "react-icons-kit";
import { check } from 'react-icons-kit/fa/check'

type TProps = {
    latitude?: number | string | null,
    longitude?: number | string | null
}

export const isValidCoord = (val: number | string | null | undefined, max: number) => {
    
    if (val === null || val === undefined || val === "") {
        return false;
    }
    
    const num = Number(val);
    
    if (isNaN(num)) { 
        return false;
    }
    
    return num >= -max && num <= max;
}

export default function MapButton({ latitude, longitude }: TProps) {
    const bothSet = latitude !== undefined && latitude !== null && latitude !== ""
                 && longitude !== undefined && longitude !== null && longitude !== "";

    const validCoords = isValidCoord(latitude, 90) && isValidCoord(longitude, 180);

    const disabled = !bothSet || !validCoords;

    const handleClick = () => {
        window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, '_blank');
    };

    return (
        <Button disabled={disabled} onClick={handleClick} bsClass="btn btn-sm btn-primary">
            <Icon icon={check} /> Verify
        </Button>
    );
}